import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { stateOptions, countryOptions } from "layouts/views/common/options";

import { FormTitle, Text, SelectField } from "ui-components/Form";

const option = {
  state: stateOptions,
  country: countryOptions,
};
function CompanyInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Company Information" : "Company Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (data.type) {
                case "text":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  renderField = <SelectField field={fieldProps} options={option[data.name]} />;
                  break;
              }
              return (
                <Grid item xs={6} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default CompanyInfo;
